module.exports = __webpack_public_path__ + "static/sjcrh-logo-red-8fb033574f0cd0fcc0221c6974f137fb.png";